import { BarItem, BarLabelContext } from '@mui/x-charts';
import { formatPercentageNumber } from '../../../../../../utils-display';
import { SingleDatasetChartData } from '../common/common-chart-types';
import {
  MuiPieChartDataConfig,
  ProcessChartDataOptions,
} from './pie-chart-types';

export const getMuiPieChartDataConfigFromChartData = (
  chartData: SingleDatasetChartData,
  options: ProcessChartDataOptions
): MuiPieChartDataConfig => {
  const { dataMap, labels } = chartData;
  const { showLabels } = options;
  let series: MuiPieChartDataConfig['series'];
  const { datasets } = chartData;
  const datasetFromProps = datasets[0];
  series = [
    {
      data: labels.map((label) => ({
        id: label,
        value: dataMap[label][0].value,
        label: label,
      })),
      valueFormatter: ({ value }: { value: number }) => {
        return datasetFromProps.valueFormatter?.(value) ?? String(value);
      },
      arcLabel: showLabels
        ? (item) => {
            return (
              datasetFromProps.valueFormatter?.(item.value) ??
              String(item.value)
            );
          }
        : undefined,
    },
  ];
  return {
    series,
  };
};

const valueFormatter = (
  value: number | null,
  showPercentage: boolean,
  dataValueFormatter?: (dataValue: number) => string
) => {
  if (value === null) {
    return '';
  }
  return showPercentage
    ? formatPercentageNumber(value)
    : (dataValueFormatter?.(value) ?? String(value));
};

export const getBarLabelConfig = ({
  dataValueFormatter,
  showPercentage,
}: {
  dataValueFormatter?: (dataValue: number) => string;
  showPercentage: boolean;
}) => {
  return (item: BarItem, context: BarLabelContext) => {
    if (context.bar.height < 10) {
      return null;
    }
    if (
      item.value &&
      ((context.bar.width < 35 && item.value > 1000) ||
        (context.bar.width < 25 && item.value > 100))
    ) {
      return null;
    }
    const formattedValue = valueFormatter(
      item.value ?? null,
      showPercentage,
      dataValueFormatter
    );
    return formattedValue;
  };
};
